import { connect } from 'react-redux';
import Callback from '../../features/Callback/Callback';
import { callback, error } from '../../actions/global/auth';

const mapDispatchToProps = dispatch => ({
  login: jwtToken => {
    dispatch(callback(jwtToken));
  },
  error: message => {
    dispatch(error(message));
  },
});

const CallbackPage = connect(
  null,
  mapDispatchToProps,
)(Callback);

export default CallbackPage;
